module.exports = __webpack_public_path__ + "img/4_73.a5e2aac6.png";